import { render, staticRenderFns } from "./Signage1.vue?vue&type=template&id=cbd5b296&scoped=true"
import script from "./Signage1.vue?vue&type=script&lang=js"
export * from "./Signage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd5b296",
  null
  
)

export default component.exports